import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "grid gap-6 grid-cols-6" }
const _hoisted_2 = { class: "flex flex-row items-end space-x-3" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "flex items-end justify-between" }
const _hoisted_6 = { class: "flex gap-x-16" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "font-semibold text-black-lp-300" }
const _hoisted_9 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300" }
const _hoisted_12 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_13 = {
  class: "space-y-2",
  "data-testid": "outgoing-sti-sc-update-total-weight"
}
const _hoisted_14 = { class: "font-semibold text-black-lp-300" }
const _hoisted_15 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_16 = { class: "space-y-2" }
const _hoisted_17 = { class: "font-semibold text-black-lp-300" }
const _hoisted_18 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_19 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_20 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('stiSc.updateV2.pageTitle'),
      "vertical-separator": false,
      "is-floating-action": true,
      fullPage: ""
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('stiSc.updateV2.partnerName'),
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.dataProfile.account_type_detail.company_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataProfile.account_type_detail.company_name = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('stiSc.updateV2.userType'),
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.typeUser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeUser = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('stiSc.updateV2.stiScDate'),
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Datepicker, {
                class: "mt-1.5",
                disabled: "",
                modelValue: _ctx.stiScDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.stiScDate = $event)),
                placeholder: _ctx.$t('stiSc.updateV2.vehicleSerialPlaceholder')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            class: "w-13/20",
            label: _ctx.$t('stiSc.table.sttNo')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                onEnter: _ctx.processData,
                onChange: _ctx.resetBadge,
                sizeInput: "24px",
                labelStacked: _ctx.$t('stiSc.updateV2.sttLabel'),
                modelValue: _ctx.form.sttNumber,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.sttNumber = $event)),
                placeholder: _ctx.$t('stiSc.updateV2.sttPlaceholder'),
                bold: !!_ctx.form.sttNumber
              }, null, 8, ["onEnter", "onChange", "labelStacked", "modelValue", "placeholder", "bold"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.isBadgeProcess)
            ? (_openBlock(), _createBlock("div", {
                class: "w-7/20 flex flex-row space-x-2 h-full items-center mb-2",
                key: _ctx.badgeProcess.icon
              }, [
                _createVNode(_component_Icons, {
                  name: _ctx.badgeProcess.icon,
                  class: "w-20"
                }, null, 8, ["name"]),
                _createVNode("div", {
                  class: [_ctx.badgeProcess.style, "flex flex-col text-14px px-4 py-3 space-y-1 rounded-lg text-left w-full"]
                }, [
                  _createVNode("div", _hoisted_3, _toDisplayString(_ctx.badgeProcess.title), 1),
                  _withDirectives(_createVNode("div", null, null, 512), [
                    [_directive_sanitize_html, _ctx.badgeProcess.message]
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.stiScData.data.stiSCList.length)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('stiSc.updateV2.summaryTotalStt')), 1),
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.stiScData.data.totalSTT), 1)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('stiSc.updateV2.summaryTotalPieces')), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.formatQuantity(_ctx.stiScData.data.totalPieces)), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('stiSc.updateV2.summaryTotalGrossWeight')), 1),
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatWeight(_ctx.stiScData.data.totalGrossWeight)), 1)
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('stiSc.updateV2.summaryTotalVolumeWeight')), 1),
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatWeight(_ctx.stiScData.data.totalVolumeWeight)), 1)
                  ])
                ]),
                _createVNode(_component_LpButton, {
                  onClick: _ctx.togglePanel,
                  icon: _ctx.isPanelVisible ? 'chevron-up-white' : 'chevron-down-white',
                  title: _ctx.$t('stiSc.updateV2.processManifest'),
                  textColor: "white"
                }, null, 8, ["onClick", "icon", "title"]),
                _createVNode(_component_OverlayPanel, {
                  ref: "op",
                  appendTo: "body",
                  style: {"width":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpButton, {
                      class: "w-60",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onProcessManifest(false))),
                      flat: "",
                      dense: "",
                      iconLeft: "sti-sc",
                      title: _ctx.$t('stiSc.updateV2.processManifest')
                    }, null, 8, ["title"]),
                    _hoisted_19,
                    _createVNode(_component_LpButton, {
                      class: "w-full",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onProcessManifest(true))),
                      flat: "",
                      dense: "",
                      iconLeft: "printer",
                      title: _ctx.$t('stiSc.updateV2.processAndPrintManifest')
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_TableV2, {
                  loading: _ctx.loadingModal,
                  data: _ctx.stiScData.data.stiSCList,
                  columns: _ctx.columns,
                  borderTop: false,
                  onRequest: _ctx.onGetSession,
                  pagination: _ctx.stiScData.pagination,
                  "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => (_ctx.stiScData.pagination = $event)),
                  "is-quick-search": "",
                  "pagination-style": "v3",
                  autoHeight: "",
                  isPinnedScrollBottom: false
                }, null, 8, ["loading", "data", "columns", "onRequest", "pagination"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('stiSc.updateV2.leaveTitle'),
      message: _ctx.$t('stiSc.updateV2.leaveBody'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('stiSc.updateV2.leaveExit'),
      textCancel: _ctx.$t('stiSc.updateV2.leaveBack'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ])
  ], 64))
}